@if (open()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center p-4">
    <button
      type="button"
      class="fixed inset-0 bg-black/40"
      aria-label="Cerrar"
      (click)="onBackdropClick()"
    ></button>

    <!-- US-098: la caja se limita al alto disponible (viewport menos el p-4 del contenedor); sólo el
         cuerpo hace scroll, así el título y el botón de cerrar quedan siempre visibles. -->
    <div
      class="relative flex max-h-full w-full max-w-lg flex-col rounded-lg border border-gray-200 bg-white p-4 shadow-lg md:p-6"
      data-modal-box
    >
      <div class="mb-4 flex shrink-0 items-center justify-between">
        @if (title()) {
          <h3 class="text-base font-semibold text-gray-900">{{ title() }}</h3>
        }
        <button type="button" class="text-gray-400 hover:text-gray-600" aria-label="Cerrar" (click)="onClose()">
          ✕
        </button>
      </div>

      <!-- -m-1 p-1: deja 4 px de aire para que el scroll no recorte los anillos de foco (outline-offset-2)
           de los campos; el contenido queda exactamente en la misma posición que antes. -->
      <div class="-m-1 min-h-0 overflow-y-auto p-1" data-modal-body>
        <ng-content />
      </div>
    </div>
  </div>
}
